import { useSelector } from 'react-redux';

const useEcommerceDisabled = () => {
  const { ecommerceDisabled } = useSelector((state) => state.site);
  return ecommerceDisabled;
};

export default useEcommerceDisabled;
